export default __webpack_public_path__ + "graphics/tea.35871b4a.jpg";